<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar">
    <!-- Menu -->
    <div class="menu">
      <ul
        class="list unselectable"
        [ngStyle]="{
          position: 'relative',
          'max-height': listMaxHeight + 'px',
          'max-width': listMaxWidth + 'px'
        }"
      >
        <li>
          <div class="sidebar-profile clearfix">
            <div class="profile-info">
              <h3>{{ user.lastName + ' ' + user.firstName }}</h3>
              <p>{{ user.role?.nameRu }}</p>
              <h3>$1 = {{ adminService.currentCourse?.value }} ₸</h3>
            </div>
          </div>
        </li>
        <!-- Top Most level menu -->
        <li
          [class.active]="
            level1Menu === sidebarItem.moduleName &&
            sidebarItem.submenu.length != 0
          "
          *ngFor="let sidebarItem of sidebarItems"
          [routerLinkActive]="sidebarItem.submenu.length != 0 ? '' : 'active'"
        >
          <div class="header" *ngIf="sidebarItem.groupTitle === true">
            {{ sidebarItem.title }}
          </div>
          <a
            [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
            *ngIf="!sidebarItem.groupTitle"
            [ngClass]="[sidebarItem.class]"
            (click)="callLevel1Toggle($event, sidebarItem.moduleName)"
            class="menu-top"
          >
            <i-feather
              [name]="sidebarItem.icon"
              class="sidebarIcon"
            ></i-feather>
            <span class="hide-menu">{{ sidebarItem.title }} </span>
          </a>
          <!-- First level menu -->
          <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0">
            <li
              [ngClass]="
                level2Menu === sidebarSubItem.moduleName ? 'activeSub' : ''
              "
              *ngFor="let sidebarSubItem of sidebarItem.submenu"
              [routerLinkActive]="
                sidebarSubItem.submenu.length > 0 ? '' : 'active'
              "
            >
              <a
                [routerLink]="
                  sidebarSubItem.submenu.length > 0
                    ? null
                    : [sidebarSubItem.path]
                "
                (click)="callLevel2Toggle($event, sidebarSubItem.moduleName)"
                [ngClass]="[sidebarSubItem.class]"
              >
                {{ sidebarSubItem.title }}
              </a>
              <!-- Second level menu -->
              <ul class="ml-menu-2" *ngIf="sidebarSubItem.submenu.length > 0">
                <li
                  *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu"
                  [ngClass]="
                    level3Menu === sidebarSubsubItem.moduleName
                      ? 'activeSubSub'
                      : ''
                  "
                  [routerLinkActive]="
                    sidebarSubsubItem.submenu.length > 0 ? '' : 'active'
                  "
                >
                  <a
                    [routerLink]="
                      sidebarSubsubItem.submenu.length > 0
                        ? null
                        : [sidebarSubsubItem.path]
                    "
                    (click)="
                      callLevel3Toggle($event, sidebarSubsubItem.moduleName)
                    "
                    [ngClass]="[sidebarSubsubItem.class]"
                  >
                    {{ sidebarSubsubItem.title }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
